export const lt = (a: string, b: string) => compareVersion(a, b) === -1;
export const lte = (a: string, b: string) => compareVersion(a, b) !== 1;
export const eq = (a: string, b: string) => compareVersion(a, b) === 0;
export const gte = (a: string, b: string) => compareVersion(a, b) !== -1;
export const gt = (a: string, b: string) => compareVersion(a, b) === 1;

export const compareVersion = (currentVersion: string, targetVersion: string) => {
  const currentVersionNumber = currentVersion.split('.').map(Number);
  const targetVersionNumber = targetVersion.split('.').map(Number);

  for (let i = 0; i < 3; i += 1) {
    if ((currentVersionNumber[i] ?? 0) > (targetVersionNumber[i] ?? 0)) return 1;
    if ((currentVersionNumber[i] ?? 0) < (targetVersionNumber[i] ?? 0)) return -1;
  }
  return 0;
};
